<template>
    <div>
        <!-- 一级Tab：星期切换 -->
        <el-tabs type="border-card" v-model="activeMainWarehouse" @tab-click="handleMainWarehouseChange">
            <el-tab-pane label="周一" name="周一"></el-tab-pane>
            <el-tab-pane label="周二" name="周二"></el-tab-pane>
            <el-tab-pane label="周三" name="周三"></el-tab-pane>
            <el-tab-pane label="周四" name="周四"></el-tab-pane>
            <el-tab-pane label="周五" name="周五"></el-tab-pane>
            <el-tab-pane label="周六" name="周六"></el-tab-pane>
            <el-tab-pane label="周日" name="周日"></el-tab-pane>
        </el-tabs>

        <!-- 二级Tab：餐次切换 -->
        <el-tabs type="card" v-model="activeSubWarehouse" @tab-click="handleSubWarehouseChange"
            style="margin-top: 10px;">
            <el-tab-pane v-for="(sub, idx) in subWarehouseList[activeMainWarehouse]" :key="idx" :label="sub"
                :name="sub">
            </el-tab-pane>
        </el-tabs>

        <!-- 食材列表区域 -->
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="食材名称">
                        <el-input v-model="searchForm.materialName" placeholder="请输入食材名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getMaterialList()">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24">
                <el-table ref="tableRef" :data="filteredMaterialList" height="65vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column label="菜品图片" align="center" width="100">
                        <template #default="scope">
                            <el-image :src="scope.row.imageUrl" :preview-src-list="[scope.row.imageUrl]" fit="cover"
                                style="width: 60px; height: 60px; border-radius: 4px;"
                                :alt="scope.row.materialName + '图片'">
                                <div slot="error" class="image-error">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="materialCode" label="菜品名称" align="center" />
                    <el-table-column prop="materialName" label="在售价格" align="center" />
                    <!-- <el-table-column label="操作" align="center" width="180">
                        <template #default="scope">
                            <el-button type="text" size="small" class="text-orange-500"
                                @click="showEditDialog(scope.row)">
                                编辑
                            </el-button>
                            <el-button type="text" size="small" class="text-red-500"
                                @click="handleDelete(scope.row.id)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

                <!-- 分页 -->
                <div style="margin-top: 20px; text-align: center;" v-if="totalCount > 0">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getDishArrangementList } from "@/api/planning";
export default {
    name: 'StockMaterialManage',
    data() {
        return {
            // 仓库Tab切换
            activeMainWarehouse: '周一',
            activeSubWarehouse: '全部',
            subWarehouseList: {
                '周一': ['全部', '早餐', '午餐', '晚餐', '宵夜'],
                '周二': ['全部', '早餐', '午餐', '晚餐', '宵夜'],
                '周三': ['全部', '早餐', '午餐', '晚餐', '宵夜'],
                '周四': ['全部', '早餐', '午餐', '晚餐', '宵夜'],
                '周五': ['全部', '早餐', '午餐', '晚餐', '宵夜'],
                '周六': ['全部', '早餐', '午餐', '晚餐', '宵夜'],
                '周日': ['全部', '早餐', '午餐', '晚餐', '宵夜']
            },

            // 搜索与分页
            searchForm: {
                materialName: ''
            },
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            allMaterialList: [],
            filteredMaterialList: [],

            // 表单数据
            dialogVisible: false,
            form: {
                id: '',
                materialCode: '',
                materialName: '',
                imageUrl: '',
                warehouseName: ''
            }
        };
    },
    mounted() {
        this.initAllMaterialList();
        this.filterMaterialByWarehouse();
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            getDishArrangementList({ userId: localStorage.getItem('userId') }).then(response => {
                console.log(response);

            })
        },
        // 仓库切换处理
        handleMainWarehouseChange() {
            this.activeSubWarehouse = this.subWarehouseList[this.activeMainWarehouse][0];
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
        },

        handleSubWarehouseChange() {
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
        },

        // 筛选当前仓库食材
        filterMaterialByWarehouse() {
            const targetWarehouse = `${this.activeMainWarehouse}-${this.activeSubWarehouse}`;
            let filtered = this.allMaterialList.filter(item => item.warehouseName === targetWarehouse);
            filtered = this.filterBySearchForm(filtered);

            this.totalCount = filtered.length;
            this.filteredMaterialList = filtered.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize
            );
        },

        // 初始化食材数据
        initAllMaterialList() {
            const typeImages = {
                vegetable: 'https://picsum.photos/id/139/200/200',
                meat: 'https://picsum.photos/id/488/200/200',
                seafood: 'https://picsum.photos/id/493/200/200',
                grainOil: 'https://picsum.photos/id/292/200/200',
                driedGoods: 'https://picsum.photos/id/225/200/200'
            };
            const materialNames = ['白菜', '猪肉', '草鱼', '大米', '香菇', '番茄', '牛肉', '虾', '面粉', '木耳'];
            const prices = [12.9, 38.5, 25.8, 4.5, 18.6, 6.8, 52.0, 45.5, 3.8, 22.3];

            const allData = [];
            Object.entries(this.subWarehouseList).forEach(([mainWarehouse, subWarehouses]) => {
                subWarehouses.forEach(subWarehouse => {
                    const subData = Array.from({ length: 8 }, (_, i) => {
                        const idx = i % materialNames.length;
                        const materialType = ['vegetable', 'meat', 'seafood', 'grainOil', 'driedGoods'][idx % 5];

                        return {
                            id: `${mainWarehouse}-${subWarehouse}-${i + 1}`,
                            materialCode: materialNames[idx],
                            materialName: prices[idx],
                            imageUrl: typeImages[materialType],
                            warehouseName: `${mainWarehouse}-${subWarehouse}`
                        };
                    });
                    allData.push(...subData);
                });
            });

            this.allMaterialList = allData;
        },

        // 搜索筛选
        filterBySearchForm(data) {
            const { materialName } = this.searchForm;
            return data.filter(item =>
                materialName ? item.materialCode.includes(materialName) : true
            );
        },

        getMaterialList() {
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.filterMaterialByWarehouse();
        },

        // 弹窗操作
        showEditDialog(row) {
            this.dialogVisible = true;
            this.form = { ...row };
        },

        // 删除操作
        handleDelete(id) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.allMaterialList = this.allMaterialList.filter(item => item.id !== id);
                this.filterMaterialByWarehouse();
                this.$message.success('删除成功');
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        handleRowClick(row) {
            this.$refs.tableRef?.toggleRowSelection(row);
        }
    }
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.text-orange-500 {
    color: #e6a23c;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.image-error {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #8c939d;
}

::v-deep .el-tabs__header {
    margin-bottom: 0 !important;
}
</style>